<style src="./NewResponsabilities.scss" lang="scss" scoped></style>
<template>
  <section class="new-client">
     <form @submit.prevent="submitForm" class="row">
    <textbox
      class="col-12"
      :autofocus="true"
      label="Nome do cliente"
      placeholder="Ambiente Municipal de São Pedro do Norte"
      v-model="form.name" />

    <textbox
      class="col-12"
      label="Nome curto do cliente"
      placeholder="AM de São Pedro do Norte"
      v-model="form.shortName" />

    <textbox
      class="col-12"
      label="Código externo"
      placeholder="22985"
      v-model="form.externalCode" />

    <div class="commands col-12">
      <button-submit
        class="col-5"
        label="Salvar Cliente"
        :state="commands.submitState"
        :icon-save="commands.saveIcon"/>

      <button
        class="btn-ghost col-5 cancel-button"
        type="button"
        @click="closePanel">
        <icon-close />
        Cancelar
      </button>
    </div>
  </form>
  </section>
</template>

<script>
// import { IconSave, IconClose } from '@/components/primitives/icons'
// import NewResponsabilities from '@/brain/record/client/AddNewClient'

export default {
  name: 'NewResponsabilities',
  data () {
    return {}
  },
  methods: {
    closePanel () {
      this.$parent.$emit('close', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/responsabilities/components/new-responsabilities/NewResponsabilities.vue